import { DOC_FLOW_ENTITY } from '../../constants/entity'
import { getApi, patchApi, postApi } from '../../utils/api'

import { DOC_FLOW_API_URL } from './DocFlow.constants'

export function createDocFlow(data) {
  return postApi({
    data,
    endpoint: `/api/${DOC_FLOW_ENTITY.single}/${DOC_FLOW_ENTITY.plural}/`,
  })
}

export function connectDocFlowRequests({ data, id }) {
  return postApi({
    data,
    endpoint: `${DOC_FLOW_API_URL}${id}/connected-requests/connect/`,
  })
}

export function disconnectDocFlowRequests({ data, id }) {
  return postApi({
    data,
    endpoint: `${DOC_FLOW_API_URL}${id}/connected-requests/disconnect/`,
  })
}

export function updateDocFlowProfile(data, id) {
  return patchApi({ data, endpoint: `${DOC_FLOW_API_URL}${id}/` })
}

export function getDocFlowEpostValidationPreview({ documentId, sendingId }) {
  return getApi({
    endpoint: `${DOC_FLOW_API_URL}${documentId}/sending-files/${sendingId}/epost-validation-preview/`,
  })
}
